// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'field-dot';

export const Component = () => (
  <g stroke='currentColor'>
    <path
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M16.313 5.061H1.688c-.622 0-1.125.504-1.125 1.125v5.625c0 .621.503 1.125 1.125 1.125h14.624c.622 0 1.125-.504 1.125-1.125V6.186c0-.621-.503-1.125-1.125-1.125z'
    />
    <circle cx='4' cy='9' r='1' fill='currentColor' />
  </g>
);

export const viewBox = '0 0 18 18';
